export const chat = {
  ws_admin: "chat/ws/admin/",
  open_sessions: "chat/admin/sessions/open/",
  my_sessions: "chat/admin/sessions/my/",
  session: "chat/admin/session/",
  send_message: "chat/admin/message/",
  claim: "chat/admin/claim/",
  close: "chat/admin/close/",
  upload: "chat/upload/",
  read: "chat/message/read/",
  notifications: "chat/admin/notifications/",
  notifications_count: "chat/admin/notifications/count/",
  notifications_read: "chat/admin/notifications/read/",
  notifications_read_all: "chat/admin/notifications/read-all/",
};
